var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filtered-search',{staticClass:"gl-w-full",attrs:{"namespace":"","tokens":_vm.tokens,"search-input-placeholder":_vm.$options.i18n.search,"initial-filter-value":_vm.getFilteredSearchValue},on:{"onFilter":_vm.handleFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }